module.exports = __webpack_public_path__ + "static/media/2.074063f5.jpg";